import {
  HeaderCellProps,
} from 'spindl-shared-components';


type ColumnHeadersInternalProps = {
  nameHeader?: HeaderCellProps;
  emailHeader?: HeaderCellProps;
  roleHeader?: HeaderCellProps;
  loginHeader?: HeaderCellProps;
  signupHeader?: HeaderCellProps;
  statusHeader?: HeaderCellProps;
  emptyHeader?: HeaderCellProps;
};

type ColumnHeadersPropsValues = {
  '': ColumnHeadersInternalProps;
};

const propValues: ColumnHeadersPropsValues = {
  '': {
    nameHeader: {
      state: 'Default',
      type: 'Default',
      size: 'M',
    },
    emailHeader: {
      state: 'Default',
      type: 'Default',
      size: 'L',
    },
    roleHeader: {
      state: 'Default',
      type: 'Tooltip',
      size: 'M',
    },
    loginHeader: {
      state: 'Default',
      type: 'Tooltip',
      size: 'M',
    },
    signupHeader: {
      state: 'Default',
      type: 'Tooltip',
      size: 'M',
    },
    statusHeader: {
      state: 'Default',
      type: 'Tooltip',
      size: 'M',
    },
    emptyHeader: {
      state: 'Descending',
      type: 'Empty',
      size: 'FullWidth',
    },
  },
};

const getProps = (type: string): ColumnHeadersInternalProps => {
  const values: ColumnHeadersInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
